import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { makeGroupsAccTeamData } from '../../utils/balance-accounts';
import TeamAccountsTable from '../../components/groups-accounts/TeamAccountsTable';

const TeamAccountsContainer = ({
  selectedYear,
  selectedHq,
  selectedTeam,
  tableRef,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();

  const onLoadData = () => {
    setLoading(true);
    const loadedData = makeGroupsAccTeamData();
    console.log(JSON.stringify(loadedData));
    setData(loadedData);
    setLoading(false);
  };

  useEffect(() => {
    onLoadData();
  }, [selectedYear, selectedHq, selectedTeam]);

  const content = loading ? (
    <Box sx={{ display: 'flex' }}>
      <CircularProgress />
    </Box>
  ) : (
    <TeamAccountsTable
      data={data || []}
      loading={loading}
      tableRef={tableRef}
    />
  );

  return content;
};

export default TeamAccountsContainer;
